
export default {
  name: "WhyBraingymjr",
  data() {
    return {
      whyTab: null
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    }
  },
  methods: {
    getFullImagePath(name) {
      return `${this.$config.API_URL}/images/WhyBraingymjr/${name}`;
    }
  }
};
